import * as LoadsConstants from './loads.constants';

export default LoadsConstants;
